
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prensa",
      function () {
        return require("private-next-pages/prensa/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prensa"])
      });
    }
  